import { useBunja } from 'bunja/react';
import { useAtom, useAtomValue } from 'jotai';

import { SocialType } from '@flipster/apis/v1/user/types';
import { stack } from '@flipster/styled-system/patterns';

import { editProfileBunja } from '../../../bunja';
import { Input } from '../../input';
import { CommunitySizeInput } from './shared/community-size-input';

interface SocialLinkItemProps {
  type: SocialType;
  label: string;
}
export const SocialLinkItem = ({ type, label }: SocialLinkItemProps) => {
  const { isMasterTraderAtom, socialForms } = useBunja(editProfileBunja);
  const isMasterTrader = useAtomValue(isMasterTraderAtom);
  const { formAtom, strippedSocialLinkAtom, validationAtom } = socialForms[type];
  const [form, setForm] = useAtom(formAtom);
  const stripped = useAtomValue(strippedSocialLinkAtom);
  const validation = useAtomValue(validationAtom);
  return (
    <div className={stack({ gap: 8 })}>
      <Input
        name={type}
        label={label}
        value={form.link}
        onChange={(e) => setForm('link', e.currentTarget.value)}
        onXClick={stripped ? () => setForm('link', '') : undefined}
        error={!validation.link && 'Invalid link. Please check the format.'}
      />
      {isMasterTrader && <CommunitySizeInput type={type} />}
    </div>
  );
};
